import { BiFilterAlt } from 'react-icons/bi';

import Button from '@/components/@base/button';
import { VARIANT_ENUM } from '@/components/@base/button/type';
import Props from '@/components/app/archive/components/filter/mobile/show-filter-button/type';

import ICON_SIZE from '@/constant/icon-size-color';
import { pageLevelLocalization } from '@/constant/localization';
const { archive: archiveLocalization } = pageLevelLocalization;

export default function ShowFilterButton({ onShowFilterClick }: Props) {
  return (
    <Button
      variant={VARIANT_ENUM.OUTLINED}
      Icon={<BiFilterAlt size={ICON_SIZE.md} strokeWidth={1.5} />}
      onClick={onShowFilterClick}
      className='my-2 h-[54px] w-full border-[#FF9606] bg-[#FFFFFF] text-[15px] font-bold text-[#FF9606] md:hidden'
    >
      {archiveLocalization.showFilter}
    </Button>
  );
}
